import { AboutSection } from '../../features/AboutSection'
import { ContactSection } from '../../features/ContactSection'
import { FeaturesSection } from '../../features/FeaturesSection'
import { GallerySection } from '../../features/GallerySection'
import { HeroSection } from '../../features/HeroSection'

export const MainPage = () => {
    return (
        <>
            <HeroSection />
            <AboutSection />
            <FeaturesSection />
            <GallerySection />
            {/* <PriceSection /> */}
            <ContactSection />
        </>
    )
}
